import { useEffect } from 'react';
import { useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { Dispatch } from "redux"
import * as actions from './../../shared/StoreContainer/actionCreators';

import { MapModule } from "../../features/map";
import { MainSample } from "../../features/mainSample/ui";

// import classNames from "./styles.module.scss"

export const Home = () => {
  const dispatch: Dispatch<any> = useDispatch()

  let { location } = useParams();
  useEffect(() => {
    console.log(location)
    location && dispatch(actions.setLocation(location))
    // eslint-disable-next-line
  }, [location])

  return <MainSample map={<MapModule />} />;

}